import { render, staticRenderFns } from "./PdfTable.vue?vue&type=template&id=68383659&scoped=true&"
import script from "./PdfTable.vue?vue&type=script&lang=js&"
export * from "./PdfTable.vue?vue&type=script&lang=js&"
import style0 from "./PdfTable.vue?vue&type=style&index=0&id=68383659&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68383659",
  null
  
)

export default component.exports